// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "../Types/PaymentModeType.bs.js";

function InfoElement(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var selectedOption = PaymentModeType$OrcaPaymentPage.paymentMode(Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom));
  var tmp;
  switch (selectedOption) {
    case "ACHTransfer" :
    case "SepaTransfer" :
    case "InstantTransfer" :
    case "InstantTransferFinland" :
    case "InstantTransferPoland" :
    case "BacsTransfer" :
    case "Boleto" :
        tmp = localeString.bankDetailsText;
        break;
    default:
      tmp = localeString.redirectText;
  }
  return React.createElement("div", {
              className: "InfoElement flex flex-row w-full pr-3 gap-3",
              style: {
                color: themeObj.colorText,
                fontSize: themeObj.fontSizeLg,
                fontWeight: themeObj.fontWeightLight,
                opacity: "60%"
              }
            }, React.createElement("div", undefined, React.createElement(Icon$OrcaPaymentPage.make, {
                      name: "redirect",
                      size: 55,
                      shouldMirrorIcon: localeString.localeDirection === "rtl"
                    })), React.createElement("div", {
                  className: "self-center"
                }, tmp));
}

var make = InfoElement;

export {
  make ,
}
/* react Not a pure module */
